<div class="container-fluid contentHeight  lacourrenting">
    <h1 class="text-center containerTitle">Gestion des formulaires de location</h1>
    <!-- <h1 class="text-center">Gestion des formulaires de location</h1> -->
    <nav>
        <div class="nav nav-tabs  bg-light" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-stat0-tab" data-toggle="tab" role="tab" aria-controls="nav-stat0"
               aria-selected="false" (click)="toggleTab('0', 'nav-stat0','nav-stat0-tab')">Formulaires en attente</a>

            <a class="nav-item nav-link" id="nav-stat4-tab" data-toggle="tab" role="tab" aria-controls="nav-stat4"
               aria-selected="false" (click)="toggleTab('4', 'nav-stat4','nav-stat4-tab')">Formulaires paiement comptant</a>

            <a class="nav-item nav-link" id="nav-stat1-tab" data-toggle="tab" role="tab" aria-controls="nav-stat1"
               aria-selected="false" (click)="toggleTab('1', 'nav-stat1','nav-stat1-tab')">Formulaires traités</a>

            <a class="nav-item nav-link" id="nav-stat2-tab" data-toggle="tab" role="tab" aria-controls="nav-stat2"
               aria-selected="false" (click)="toggleTab('2', 'nav-stat2','nav-stat2-tab')">Formulaires refusés/abandonnés</a>
        </div>
    </nav>
    <div class="tab-content  bg-light adminContent" id="nav-tabContent">
        <div class="row  bg-light noMargin">
            <div class="col-6">
                <mat-form-field class="ml-2">
                    <mat-label>Rechercher</mat-label>
                    <input matInput (keyup)="applyFilter($event.target.value)">
                </mat-form-field>
            </div>
            <div class="col-6">
                <div class="text-right"> <i aria-hidden="true" (click)="refreshTab()" class="fas fa-sync fa-1-2x p-2 pointer steelblue"></i> </div>
            </div>
        </div>
        <div class="tab-pane  fade show active" id="nav-stat1" role="tabpanel" aria-labelledby="nav-profile-tab">
            <mat-table class="table lstdossier bg-white table-hover" matSort [dataSource]="rentingSource" (matSortChange)="sortScale($event,'1')">
                <!-- Champs Mouvement -->
                <ng-container matColumnDef="isChecked" class="tableContainer">
                    <mat-header-cell *matHeaderCellDef> Mouvement </mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div *ngIf="res.isChecked == 0">
                            <input type="checkbox" id="res.rentingID" (change)="onIsCheckedChange(res.rentingID)">
                        </div>
                        <div *ngIf="res.isChecked == 1">
                            <input type="checkbox" checked="checked" id="res.rentingID" (change)="onIsCheckedChange(res.rentingID)">
                        </div>
                    </mat-cell>
                </ng-container>
                <!-- Champs N° de formulaire -->
                <ng-container matColumnDef="rentingId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>N° de formulaire</mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        {{res.rentingID}}
                        <i aria-hidden="true" matTooltip="Paiement comptant" *ngIf="res.cashPayement == 1" class="far fa-money-bill-wave ml-2"></i>
                    </mat-cell>
                </ng-container>
                <!-- Champs Statut -->
                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> <span class="text-center"> Statut </span></mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <i aria-hidden="true" *ngIf="res.status == 1" class="far fa-check fa-1-2x primaryGreen" matTooltip="Traité"></i>
                        <i aria-hidden="true" *ngIf="res.status == 2" class="far fa-minus-circle fa-1-2x primaryRed" matTooltip="Financement refusé"></i>
                        <i aria-hidden="true" *ngIf="res.status == 3" class="far fa-trash-alt fa-1-2x primaryGrey" matTooltip="Abandonné"></i>
                    </mat-cell>
                </ng-container>
                <!-- Champs N° de compagnie -->
                <ng-container matColumnDef="companyId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>N° de compagnie</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.companyID}}</mat-cell>
                </ng-container>
                <!-- Champs Date de demande de location -->
                <ng-container matColumnDef="rentingDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Date de création</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.rentingDate | date:'dd/MM/yyyy'}}</mat-cell>
                </ng-container>
                <!-- Champs Date de traitement -->
                <ng-container matColumnDef="treatmentDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Date de traitement</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.treatmentDate | date:'dd/MM/yyyy'}}</mat-cell>
                </ng-container>
                <!-- Champs Nom de la société-->
                <ng-container matColumnDef="companySocialReason">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Raison sociale</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.socialReason}}</mat-cell>
                </ng-container>
                <!-- Champs Pays de demande de location -->
                <ng-container matColumnDef="country">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Pays</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.country}}</mat-cell>
                </ng-container>
                <!-- Champs Identité CTC -->
                <ng-container matColumnDef="ctc">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Identité CTC</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.ctcFirstname}} {{res.ctcName}}</mat-cell>
                </ng-container>
                <!-- Champs Téléphone CTC -->
                <ng-container matColumnDef="ctcPhone">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Téléphone CTC</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.ctcPhone}}</mat-cell>
                </ng-container>
                <!-- Champs Mail CTC -->
                <ng-container matColumnDef="ctcMail">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>E-mail CTC</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.ctcMail}}</mat-cell>
                </ng-container>
                <!-- Champs Durée de location -->
                <ng-container matColumnDef="rentingDuration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Durée de location</mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div *ngIf="res.rentingDuration > 0">{{res.rentingDuration}}</div>
                    </mat-cell>
                </ng-container>
                <!-- Champs Code Unisite -->
                <ng-container matColumnDef="companyUnisiteCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Code Unisite</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.companyUnisiteCode}}</mat-cell>
                </ng-container>
                <!-- Champs Code SAGE -->
                <ng-container matColumnDef="sageCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Code SAGE</mat-header-cell>
                    <mat-cell *matCellDef="let res">{{res.sageCode}}</mat-cell>
                </ng-container>
                <!-- Champs Banque -->
                <ng-container matColumnDef="bank">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Banque</mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div *ngIf="res.bank == 0"></div>
                        <div *ngIf="res.bank == 1">BNP</div>
                        <div *ngIf="res.bank == 2">CMCIC</div>
                    </mat-cell>
                </ng-container>
                <!-- Champs N° de commande -->
                <ng-container matColumnDef="invoiceCode1">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>N° de commande</mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <span>{{res.invoiceCode}}</span>
                    </mat-cell>
                </ng-container>
                <!-- Champs Renouvellement -->
                <ng-container matColumnDef="renewal">
                    <mat-header-cell *matHeaderCellDef>Renouvellement</mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <span *ngIf="res.renewal == 1">
                            Oui
                        </span>
                        <span *ngIf="res.renewal == 0">
                            Non
                        </span>
                    </mat-cell>
                </ng-container>
                <!-- Champs Editer -->
                <ng-container matColumnDef="finalEdit">
                    <mat-header-cell *matHeaderCellDef>Editer</mat-header-cell>
                    <mat-cell *matCellDef="let res" class="pointer" (click)="displayInfoRenting(res.rentingID, 0)">
                        <i aria-hidden="true" *ngIf="res.status == 0 || res.status == 4" class="fad fa-edit  fa-1-2x twoToneLightGreen" title="Editer"></i>
                    </mat-cell>
                </ng-container>
                <!-- Champs Visualiser -->
                <ng-container matColumnDef="show">
                    <mat-header-cell *matHeaderCellDef>Visualiser</mat-header-cell>
                    <mat-cell *matCellDef="let res" class="pointer" (click)="displayInfoRenting(res.rentingID, 1)">
                        <i aria-hidden="true" class="fad fa-eye  fa-1-2x twoToneBlue" title="Editer"></i>
                    </mat-cell>
                </ng-container>
                <!-- Champs Mail -->
                <ng-container matColumnDef="mail">
                    <mat-header-cell *matHeaderCellDef>Mail</mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <span *ngIf="res.status == 1" (click)="displayMailRenting(rentingID, res.ctcMail, res.ctcLanguage)">
                            <i aria-hidden="true" class="fad fa-paper-plane fa-1-2x twoToneGreen pointer" title="Envoyer le mail"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <!-- Champs Excel -->
                <ng-container matColumnDef="excel">
                    <mat-header-cell *matHeaderCellDef>Fichier Excel</mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <span (click)="downloadExcel(res.rentingID)">
                            <i aria-hidden="true" class="fad fa-file-excel fa-1-2x twoToneGreen pointer" title="Générer le fichier Excel"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
        </div>
    </div>
    <!-- Modal - Editer -->
    <div id="editRentingModal" class="modal">
        <div class="modal-content">
            <div class="col-12 text-center">
                <span class="text-right pointer close" (click)="closeModal('editRentingModal')">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1>Informations Formulaire N° {{actualRentingID}}</h1>
            </div>
            <div *ngFor="let info of dataInfo">
                <div class="row mx-auto">
                    <div class="col-lg-6">
                        <hr>
                        <h3> <i aria-hidden="true" class="fad fa-id-card-alt twoToneBlue fa-1-2x"></i> Activité client</h3>
                        <div class="row">
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(2)">
                                    <span class="font-weight-bold"> N° compte Ixell : </span> {{ info.ixellAccount }}
                                    <span class="pointer steelblue" (click)="editIxAcc()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindIxAcc()" *ngIf="info.ixellAccount !== originalEdit.ixellAccount" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(2)">
                                    <mat-form-field>
                                        <mat-label>N° compte Ixell</mat-label>
                                        <input matInput [(ngModel)]="currIxellAccount">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateIxAcc()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelIxAcc()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(4)">
                                    <span class="font-weight-bold"> Tarif : </span> {{ info.customerStatus }}
                                    <span class="pointer steelblue" (click)="editTarif()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindTarif()" *ngIf="info.customerStatus !== originalEdit.customerStatus" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(4)">
                                    <mat-form-field>
                                        <mat-label>Tarif</mat-label>
                                        <mat-select [(ngModel)]="currTarif">
                                            <mat-option value="R1">R1</mat-option>
                                            <mat-option value="R2">R2</mat-option>
                                            <mat-option value="R3">R3</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateTarif()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelTarif()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(8)">
                                    <span class="font-weight-bold"> Technologie : </span> {{ info.technology }}
                                    <span class="pointer steelblue" (click)="editTech()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindTech()" *ngIf="info.technology !== originalEdit.technology" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(8)">
                                    <mat-form-field>
                                        <mat-label>Technologie</mat-label>
                                        <mat-select [(ngModel)]="currTech">
                                            <mat-option value="Ixelltech">Ixelltech</mat-option>
                                            <mat-option value="Oxelia">Oxelia</mat-option>
                                            <mat-option value="Equinox">Equinox</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateTech()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelTech()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(16)">
                                    <span class="font-weight-bold"> Client appartient à : </span> {{ info.companyType }}
                                    <span class="pointer steelblue" (click)="editCpnyType()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyType()" *ngIf="info.companyType !== originalEdit.companyType" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(16)">
                                    <mat-form-field>
                                        <mat-label>Client appartient à</mat-label>
                                        <mat-select [(ngModel)]="currCpnyType">
                                            <mat-option value="reseau">reseau</mat-option>
                                            <mat-option value="enseigne">enseigne</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyType()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyType()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                                <br/>
                                <ng-container *ngIf="!isEditing(32)">
                                    <span class="font-weight-bold"> Qui est : </span> {{ info.companyTypeName }}
                                    <span class="pointer steelblue" (click)="editCpnyTypeName()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyTypeName()" *ngIf="info.companyTypeName !== originalEdit.companyTypeName" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(32)">
                                    <mat-form-field>
                                        <mat-label>Qui est</mat-label>
                                        <input matInput [(ngModel)]="currCpnyTypeName">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyTypeName()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyTypeName()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <hr>
                        <h3>
                            <i aria-hidden="true" class="fad fa-user-hard-hat twoToneLightBlue fa-1-2x"></i> Informations CT
                            <ng-container *ngIf="!isEditing(1)">
                                <span class="pointer steelblue" (click)="editCT()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                <span class="pointer steelblue" (click)="rewindCT()" *ngIf="info.ctcID !== originalEdit.ctcID" title="Rétablir"><i class="fas fa-history"></i></span>
                            </ng-container>
                            <ng-container *ngIf="isEditing(1)">
                                <span class="pointer primaryGreen" (click)="validateCT()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                <span class="pointer primaryRed" (click)="cancelCT()" title="Annuler"><i class="fas fa-times"></i></span>
                            </ng-container>
                        </h3>
                        <div class="row" *ngIf="!isEditing(1)">
                            <div class="col-6">
                                <span class="font-weight-bold"> Interlocuteur CT Ixell : </span>
                                {{ info.ctcFirstname }} {{ info.ctcName}}
                            </div>
                            <div class="col-6"> <span class="font-weight-bold"> Téléphone : </span> {{ info.ctcPhone }} </div>
                            <div class="col-6"> <span class="font-weight-bold"> E-mail : </span> {{ info.ctcMail }} </div>
                        </div>
                        <div *ngIf="isEditing(1)">
                            <mat-form-field>
                                <mat-label>CT</mat-label>
                                <mat-select [(ngModel)]="currCtcId">
                                    <mat-option *ngFor="let ct of availableCTs" [value]="ct.idCtc">{{ ct.firstname }} {{ ct.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <hr>
                        <h3> <i aria-hidden="true" class="fad fa-industry-alt twoToneGreen fa-1-2x"></i> Société</h3>
                        <div class="row">
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(2048)">
                                    <span class="font-weight-bold"> Raison sociale : </span> {{ info.companySocialReason }}
                                    <span class="pointer steelblue" (click)="editSocialReason()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindSocialReason()" *ngIf="info.companySocialReason !== originalEdit.companySocialReason" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(2048)">
                                    <mat-form-field>
                                        <mat-label>Raison sociale</mat-label>
                                        <input matInput [(ngModel)]="currSocialReason">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateSocialReason()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelSocialReason()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(4096)">
                                    <span class="font-weight-bold"> Adresse : </span> {{ info.companyAddress }}
                                    <span class="pointer steelblue" (click)="editCpnyAddr()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyAddr()" *ngIf="info.companyAddress !== originalEdit.companyAddress" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(4096)">
                                    <mat-form-field>
                                        <mat-label>Adresse</mat-label>
                                        <input matInput [(ngModel)]="currCpnyAddr">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyAddr()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyAddr()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(8192)">
                                    <span class="font-weight-bold"> Code postal : </span> {{ info.companyPostalCode }}
                                    <span class="pointer steelblue" (click)="editCpnyPostalCode()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyPostalCode()" *ngIf="info.companyPostalCode !== originalEdit.companyPostalCode" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(8192)">
                                    <mat-form-field>
                                        <mat-label>Code postal</mat-label>
                                        <input matInput [(ngModel)]="currCpnyPostalCode">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyPostalCode()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyPostalCode()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(16384)">
                                    <span class="font-weight-bold"> Ville : </span> {{ info.companyCity }}
                                    <span class="pointer steelblue" (click)="editCpnyCity()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyCity()" *ngIf="info.companyCity !== originalEdit.companyCity" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(16384)">
                                    <mat-form-field>
                                        <mat-label>Ville</mat-label>
                                        <input matInput [(ngModel)]="currCpnyCity">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyCity()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyCity()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(32768)">
                                    <span class="font-weight-bold"> Pays : </span> {{ info.companyCountry }}
                                    <span class="pointer steelblue" (click)="editCpnyCountry()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyCountry()" *ngIf="info.companyCountry !== originalEdit.companyCountry" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(32768)">
                                    <mat-form-field class="col-lg-6 col-sm-12">
                                        <mat-label>Pays</mat-label>
                                        <mat-select [(ngModel)]="currCpnyCountry">
                                            <mat-option *ngFor="let country of availableCountries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyCountry()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyCountry()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(65536)">
                                    <span class="font-weight-bold"> SIREN : </span> {{ info.companySiren }}
                                    <span class="pointer steelblue" (click)="editCpnySiren()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnySiren()" *ngIf="info.companySiren !== originalEdit.companySiren" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(65536)">
                                    <mat-form-field>
                                        <mat-label>SIREN</mat-label>
                                        <input matInput [(ngModel)]="currCpnySiren">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnySiren()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnySiren()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(131072)">
                                    <span class="font-weight-bold"> n° TVA intracommunautaire : </span> {{ info.companyTva }}
                                    <span class="pointer steelblue" (click)="editCpnyTva()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyTva()" *ngIf="info.companyTva !== originalEdit.companyTva" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(131072)">
                                    <mat-form-field>
                                        <mat-label>n° TVA intracommunautaire</mat-label>
                                        <input matInput [(ngModel)]="currCpnyTva">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyTva()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyTva()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <hr>
                        <h3> <i aria-hidden="true" class="fad fa-address-card twoToneLightGreen fa-1-2x"></i> Contacts société</h3>
                        <div class="row">
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(64)">
                                    <span class="font-weight-bold"> Dirigeant : </span> {{ info.leader }}
                                    <span class="pointer steelblue" (click)="editLeader()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindLeader()" *ngIf="info.leader !== originalEdit.leader" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(64)">
                                    <mat-form-field>
                                        <mat-label>Dirigeant</mat-label>
                                        <input matInput [(ngModel)]="currLeader">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateLeader()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelLeader()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(128)">
                                    <span class="font-weight-bold"> Interlocuteur carrosserie : </span> {{ info.bodyshopInterlocutor }}
                                    <span class="pointer steelblue" (click)="editBodyshopInter()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindBodyshopInter()" *ngIf="info.bodyshopInterlocutor !== originalEdit.bodyshopInterlocutor" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(128)">
                                    <mat-form-field>
                                        <mat-label>Interlocuteur carrosserie</mat-label>
                                        <input matInput [(ngModel)]="currBodyshopInter">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateBodyshopInter()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelBodyshopInter()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(256)">
                                    <span class="font-weight-bold"> Téléphone : </span> {{ info.companyPhone }}
                                    <span class="pointer steelblue" (click)="editCpnyPhone()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyPhone()" *ngIf="info.companyPhone !== originalEdit.companyPhone" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(256)">
                                    <mat-form-field>
                                        <mat-label>Téléphone</mat-label>
                                        <input matInput [(ngModel)]="currCpnyPhone">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyPhone()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyPhone()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(512)">
                                    <span class="font-weight-bold"> E-mail : </span> {{ info.companyMail }}
                                    <span class="pointer steelblue" (click)="editCpnyEMail()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyEMail()" *ngIf="info.companyMail !== originalEdit.companyMail" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(512)">
                                    <mat-form-field>
                                        <mat-label>E-mail</mat-label>
                                        <input matInput [(ngModel)]="currCpnyEMail">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyEMail()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyEMail()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <ng-container *ngIf="!isEditing(1024)">
                                    <span class="font-weight-bold"> Ligne directe : </span> {{ info.companyDirectLign }}
                                    <span class="pointer steelblue" (click)="editCpnyDirect()" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                    <span class="pointer steelblue" (click)="rewindCpnyDirect()" *ngIf="info.companyDirectLign !== originalEdit.companyDirectLign" title="Rétablir"><i class="fas fa-history"></i></span>
                                </ng-container>
                                <ng-container *ngIf="isEditing(1024)">
                                    <mat-form-field>
                                        <mat-label>Ligne directe</mat-label>
                                        <input matInput [(ngModel)]="currCpnyDirect">
                                    </mat-form-field>
                                    <span class="pointer primaryGreen" (click)="validateCpnyDirect()" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                    <span class="pointer primaryRed" (click)="cancelCpnyDirect()" title="Annuler"><i class="fas fa-times"></i></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <!-- Commande de produits -->
                    <div *ngIf="orderLight.length > 0 || isEditable" class="col-lg-6">
                        <hr>
                        <h3>
                            <i aria-hidden="true" class="fad fa-box-full twoToneRed fa-1-2x"></i> Commande de produits
                            <span class="pointer steelblue" (click)="rewindOrder()" *ngIf="didFullOrderChange()" title="Rétablir"><i class="fas fa-history"></i></span>
                        </h3>
                        <div class="col-12 mt-3">
                            <table class="table-bordered tableorder">
                                <caption></caption>
                                <thead>
                                    <tr>
                                        <th scope="col"> Désignation </th>
                                        <th scope="col" class="text-center"> Prix </th>
                                        <th scope="col"> Quantité </th>
                                        <th scope="col" *ngIf="isEditable"> Action </th>
                                    </tr>
                                </thead>
                                <tr *ngFor="let order of orderLight">
                                    <td>
                                        {{order.labelP}}
                                    </td>
                                    <td [style.whiteSpace]="'nowrap'">
                                        {{order.amountP * order.qty | number : '1.2-2'}} €
                                    </td>
                                    <td class="text-center">
                                        <ng-container *ngIf="order.tmpQty === undefined">
                                            {{order.qty}}
                                            <span class="pointer steelblue" (click)="editProductQty(order)" *ngIf="isEditable" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                            <span class="pointer steelblue" (click)="rewindProductQty(order)" *ngIf="didOrderChange(order)" title="Rétablir"><i class="fas fa-history"></i></span>
                                        </ng-container>
                                        <ng-container *ngIf="order.tmpQty !== undefined">
                                            <mat-form-field>
                                                <mat-label>Quantité</mat-label>
                                                <input matInput type="number" [(ngModel)]="order.tmpQty" min="1" [attr.max]="getMaxForProduct(order.productID)">
                                            </mat-form-field>
                                            &nbsp;
                                            <span [style.whiteSpace]="'nowrap'">
                                                <span class="pointer primaryGreen" (click)="validateProductQty(order)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                <span class="pointer primaryRed" (click)="cancelProductQty(order)" title="Annuler"><i class="fas fa-times"></i></span>
                                            </span>
                                        </ng-container>
                                    </td>
                                    <td class="text-center primaryRed pointer" *ngIf="isEditable" title="Supprimer" (click)="removeProduct(order.productID)">
                                        <i class="fas fa-minus"></i>
                                    </td>
                                </tr>
                                <tr *ngIf="isEditable && orderLight.length < availableProducts.length" title="Ajouter">
                                    <ng-container *ngIf="!isEditing(262144)">
                                        <td colspan="4" class="text-center primaryGreen pointer" (click)="startAddProduct()"> <i class="fas fa-plus"></i> </td>
                                    </ng-container>
                                    <ng-container *ngIf="isEditing(262144)">
                                        <td colspan="4" class="text-center primaryGreen">
                                            <mat-form-field>
                                                <mat-label>Produit</mat-label>
                                                <mat-select (selectionChange)="addProductManualQty.value = updateProductQuantity(addProductManualQty.value, addProductManualType.value)" #addProductManualType>
                                                    <mat-option *ngFor="let availableProduct of getAvailableProducts()" [value]="availableProduct.productID">{{availableProduct.labelP}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            &nbsp;
                                            <mat-form-field [style.display]="addProductManualType.value === undefined ? 'none' : null">
                                                <mat-label>Quantité</mat-label>
                                                <input matInput type="number" value="1" min="1" [attr.max]="getMaxForProduct(addProductManualType.value)" #addProductManualQty>
                                            </mat-form-field>
                                            &nbsp;
                                            <span class="pointer primaryGreen" *ngIf="addProductManualType.value !== undefined" (click)="validateAddProduct(addProductManualType.value, addProductManualQty.value)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                            <span class="pointer primaryRed" (click)="cancelAddProduct()" title="Annuler"><i class="fas fa-times"></i></span>
                                        </td>
                                    </ng-container>
                                </tr>
                                <tr>
                                    <td [attr.colspan]="isEditable ? 4 : 3"> <span class="font-weight-bold"> Total </span>: {{totalAmountOrder | number : '1.2-2'}} €</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="isEditable" class="col-lg-6">
                        <hr>
                        <h3> <i aria-hidden="true" class="fad fa-info-hard-hat twoToneRedOrange fa-1-2x"></i> Autres informations</h3>
                        <div class="row">
                            <form [formGroup]="rentingAddInfosForm" class="col-12 row">
                                <mat-form-field class="col-6">
                                    <mat-label>Code Unisite</mat-label>
                                    <input matInput formControlName="companyUnisiteCode">
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>Code SAGE</mat-label>
                                    <input matInput formControlName="sageCode">
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>Banque</mat-label>
                                    <mat-select formControlName="bank">
                                        <mat-option *ngFor="let bank of listOfBanks.list" [value]="bank.value">{{bank.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>N° de commande</mat-label>
                                    <input matInput formControlName="invoiceCode">
                                </mat-form-field>
                            </form>
                        </div>
                    </div>
                    <div *ngIf="!isEditable" class="col-lg-6">
                        <hr>
                        <h3> <i aria-hidden="true" class="fad fa-info-hard-hat twoToneRedOrange fa-1-2x"></i> Autres informations</h3>
                        <div class="row">
                            <!--<div class="col-6"> <span class="font-weight-bold"> Code Unisite : </span> {{ info.companyUnisiteCode }} </div>
                            <div class="col-6"> <span class="font-weight-bold"> Code SAGE : </span> {{ info.sageCode }} </div>
                            <div class="col-6">
                              <span class="font-weight-bold"> Banque : </span>
                              <span *ngIf=" info.bank  == 1"> BNP </span>
                              <span *ngIf=" info.bank  == 2"> CMCIC </span>
                            </div>-->
                            <form [formGroup]="rentingAddInfosForm" class="col-12 row">
                                <mat-form-field class="col-6">
                                    <mat-label>Code Unisite</mat-label>
                                    <input matInput formControlName="companyUnisiteCode">
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>Code SAGE</mat-label>
                                    <input matInput formControlName="sageCode">
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>Banque</mat-label>
                                    <mat-select formControlName="bank">
                                        <mat-option *ngFor="let bank of listOfBanks.list" [value]="bank.value">{{bank.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>N° de commande</mat-label>
                                    <input matInput formControlName="invoiceCode">
                                </mat-form-field>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="text-center col-12" *ngIf="!isEditable">
                    <mat-form-field class="col-3">
                        <mat-label>Statut</mat-label>
                        <mat-select [(ngModel)]="info.status">
                            <mat-option [value]="0">En attente</mat-option>
                            <mat-option [value]="1">Accepté</mat-option>
                            <mat-option [value]="2">Refusé</mat-option>
                            <mat-option [value]="3">Abandonné</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="text-center col-12">
                    <div *ngIf="errorForm" class="col-12 text-danger text-center"> Veuillez remplir toutes les informations requises </div>
                    <div *ngIf="isPending">
                        <button class="btn btn-success mr-2" (click)="confirmToSendNewInfoAndStatus(1, info)"> Accepter </button>
                        <button class="btn btn-danger mr-2" (click)="confirmToSendNewInfoAndStatus(2, info)"> Refuser </button>
                        <button class="btn btn-dark mr-2" (click)="confirmToSendNewInfoAndStatus(3, info)"> Abandon </button>
                    </div>
                    <div>
                        <button class="btn btn-primary mr-2 col-1" (click)="confirmToSendNewInfo(0, info)"> Enregistrer </button>
                        <button class="btn btn-warning mr-2 col-1" (click)="closeModal('editRentingModal')"> Annuler </button>
                    </div>
                    <!-- <button class="btn btn-success col-3"
                            (click)="sendNewInfos(true, info.rentingID, info.companyID); sendMail(info.rentingID, info.ctcMail, info.ctcLanguage, 'editRentingModal')">
                      Enregistrer et envoyer le mail
                      <i  aria-hidden="true" class="fas fa-paper-plane ml-1"></i>
                    </button> -->
                </div>
            </div>
        </div>
    </div>

    <!-- Modal - Confirmation -->
    <div id="confirmationModal" class="modal">
        <div class="modal-content3">
            <div class="row">
                <span class="col-12 text-right pointer close" (click)="closeModal('confirmationModal')">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <div class="col-12 mx-auto text-center flex flex-column flex-center">
                    <h1> Confirmation de votre choix </h1>
                    <p> Souhaitez vous vraiment {{confirmationStatus|lowercase}} cette demande? </p>
                    <p style="white-space: pre-wrap; text-align: left;" *ngIf="additionalConfirmText.length > 0">{{additionalConfirmText}}</p>
                    <button class="btn btn-secondary" (click)="confirmationCb()"> {{confirmationStatus}} </button>
                </div>
            </div>
        </div>
        <!-- Modal - Mail -->
        <div id="mailModal" class="modal">
            <div class="modal-content3">
                <div class="row" *ngFor="let data of mailInfo">
                    <div class="col-12">
                        <span class="text-right pointer close" (click)="closeModal('mailModal')">
                            <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                        </span>
                    </div>
                    <div class="col-12">
                        <div class="text-center">
                            <p> Voulez-vous envoyer la validation de la prise en charge du formulaire à </p>
                            <span>{{ data.ctcMail }} ?</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="text-center">
                            <button class="btn btn-secondary" (click)="sendMail(data.rentingID, data.ctcMail, data.ctcLanguage, 'mailModal')"> Envoyer </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
